<template>
    <div class="header--inner" v-if="show_page">
        <router-link to="/" class="logo" title="Grapple">
            <svg width="49" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M19.418 16.763s8.608-9.884 9.093-10.242c.46-.332 2.273-1.813 5.083-1.864 2.554-.026 2.886.127 3.652.434.715.306 1.022.715 1.022.97 0 .358-.153.614-.153.614h9.654s.996-2.07.383-2.963C47.616 2.945 45.394.8 39.264.8s-9.604.409-13.69 1.941c-4.087 1.533-5.466 2.401-7.51 4.444C16.021 9.23 2.23 24.81 2.23 24.81L.696 26.852s-1.047 2.07.511 3.32c1.686 1.329 4.087 2.325 6.896 2.555 3.295.28 8.94-.255 8.94-.255s6.947-1.175 10.216-2.81c3.065-1.532 4.853-2.299 7.663-6.13 2.81-3.831 7.662-9.961 7.662-9.961h-15.07l-3.83 4.342h5.363s-5.006 6.41-5.874 7.152c-.869.74-2.299 2.273-4.853 2.554-2.86.306-4.98.05-5.62-.256-.51-.255-1.02-1.021-.766-1.532.256-.511 1.788-2.299 1.788-2.299l5.696-6.769z" fill-rule="evenodd"/></svg>
        </router-link>
        <a class="header__menu-trigger" @click="navigation"><span>Menu</span></a>
        <!--<div class="burger" @click="navigation">
        </div>-->
    </div>
</template>

<script>
export default {
    props: ['home_page'],
    computed: {
        show_page()
        {
            return this.$store.state.is_loading === false;
        }
    },
    methods: {
        navigation() {
            let vm = this;

            if( vm.$route.name == 'Home' ) {
                Event.$emit('canvas_godmode');
            }

            if ($('html').hasClass('activemenu') ) {
                Animations.menuOut();
            } else {
                Animations.menuIn();
            }
        },
        goHome( post_id ) {
            let vm = this;
            if( $('.wrap.menued').length > 0 ){
                Animations.menuOut();
            } else {
                Animations.pageOut();
            }
        }
    }
}
</script>
